import { formatCpfCnpj } from "./stringsFormats";

export const getSelectOptions = (
  data: any[],
  valueKey: string,
  labelTemplate: string
): { value: string; label: string }[] => {
  return data.map((item) => {
    const formattedLabel = labelTemplate.replace(
      /\{(\w+)\}/g,
      (_, key: string) =>
        key.toLocaleLowerCase().includes("st_cpf")
          ? formatCpfCnpj(item[key])
          : item[key]
    );

    return {
      value: item[valueKey],
      label: formattedLabel,
    };
  });
};
